import { Tooltip } from '../../tooltip/Tooltip';

export function UsageSummaryPipelineNode({
  name,
  type,
  disabled
}: {
  name: string;
  type: string;
  disabled?: boolean;
}) {
  return (
    <div
      data-id='usage-summary-pipeline-node'
      style={{ opacity: disabled ? 0.6 : 1 }}
      className='overflow-hidden flex-1'
    >
      <Tooltip dataId='' title={name} enableOnTextOverflow>
        <div className='text-body-3 text-ellipsis'>{name}</div>
      </Tooltip>

      <Tooltip dataId='' title={type} enableOnTextOverflow>
        <div className='mt-1 text-secondary text-ellipsis'>{type}</div>
      </Tooltip>
    </div>
  );
}
